/**
 * DecryptedToken
 */
class DecryptedToken {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly payload: Record<string, any>;

  /**
   * Constructor
   *
   * @param {Record<string, any>} token
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(token?: Record<string, any>) {
    this.payload = token;
  }
}

export { DecryptedToken };
